import { createAsyncThunk } from "@reduxjs/toolkit";
import { Api } from "../..";
import { API_POST_AGENT_CUSTOMER_SEARCH } from "../../Apis/ApiEndPoints";
import { CustomAction } from "../../store/customAction";
import { createAction } from "@reduxjs/toolkit";

export const PostCustomerSearch = createAsyncThunk(
  "agent/PostCustomerSearch",
  async (requestParams: Record<string, string>, { dispatch }) => {
    const response = await CustomAction(
      Api.post(API_POST_AGENT_CUSTOMER_SEARCH, requestParams),
      dispatch,
      "agent/PostCustomerSearch"
    );
    return response;
  }
);
export const clearCustomerSearchData = createAction("customerSearch/clearCustomerSearchData");  